import _distanceInWordsToNow from 'date-fns-legacy/distance_in_words_to_now'
import _format from 'date-fns-legacy/format'

import enLocale from 'date-fns-legacy/locale/en'
import frLocale from 'date-fns-legacy/locale/fr'
import esLocale from 'date-fns-legacy/locale/es'
import caLocale from 'date-fns-legacy/locale/ca'
import itLocale from 'date-fns-legacy/locale/it'
import deLocale from 'date-fns-legacy/locale/de'
import nlLocale from 'date-fns-legacy/locale/nl'

const locales = {
  en: enLocale,
  fr: frLocale,
  es: esLocale,
  ca: caLocale,
  it: itLocale,
  de: deLocale,
  nl: nlLocale
}

export function distanceInWordsToNow(date, options) {
  return _distanceInWordsToNow(date, { ...options, locale: locales[window.UFE.locale || 'en'] })
}

export function format(date, formatStr, options) {
  return _format(date, formatStr, { ...options, locale: locales[window.UFE.locale || 'en'] })
}

/**
 * Get current timestamp in seconds
 * @return {number} timestamp in second
 */
export const now = () => Math.round(+new Date() / 1000)
